<script setup lang="ts">
defineProps<{
  number: number
  title: string
  comment?: string
}>()
</script>

<template>
  <li
    :class="[
      'relative flex items-center gap-4 lg:flex-col',
      'w-full px-2 py-4 sm:px-8 lg:w-48 lg:px-4 lg:pt-12',
      'transition-all',
    ]"
  >
    <div
      class="flex h-12 w-12 items-center justify-center rounded-lg bg-main-50 text-lg font-bold tabular-nums text-main-900 bordershadow-lg-main"
    >
      {{ number }}
    </div>

    <div class="flex w-full flex-1 flex-col text-left lg:items-center lg:text-center">
      <Heading size="small">
        {{ title }}
      </Heading>
      <Paragraph size="small">
        {{ comment }}
      </Paragraph>
    </div>
  </li>
</template>
